/* eslint no-underscore-dangle: ["error", { "allow": ["_id"]}] */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, FormattedMessage } from 'react-intl';
import TimeLinePagenation from './TimeLinePagenation';
import TimeLineSearchBox from './TimeLineSearchBox';
import TimeLineToolBar from './TimeLineToolBar';
import TimeLineLists from './TimeLineLists';
import UpdateTagsDialog from './UpdateTagsDialog';
import DeviceList from './DeviceList';
import MediaMap from '../Map/MediaMap';
import { convertUnixtTimeToDateTime } from '../../lib/tools';
import config from '../../config';
import UserIcon from '../Parts/UserIcon';
import iconGrid from '../../images/common/menuTile.svg';
import iconList from '../../images/common/menuList.svg';
import {
  disableWorkRecords,
  download,
  downloadCheckResult,
} from '../../actions/operatorWorks';
import {
  OperatorImage,
  OperatorBox,
  Table,
  Tbody,
  OperatorInfo,
  TitleBar,
  TitleBarText,
  ToolButton,
  ToolIcon,
  Operator01,
  Thumbnail,
  ImageWrapper,
  MediaIconP,
  MediaIconL,
  List,
  ListsWrapper,
  MapBox,
  style,
  PlayCircleStyle,
} from './styles/TimeLineTileListsStyles';
import { getMediaIconSrc } from './functions/getMediaIconSrc';
import { ReactComponent as PlayCircle } from '../../images/common/play_circle.svg';
import { VIDEO } from '../../lib/constants';

const { deleteData } = config.customRole.functionAccess;

const createList = (intl, idx, list, open) => {
  const mediaType = list.mediaType || 0;
  const thumbnailUrl = list.thumbnailUrl || null;
  const convertRecordedDate = convertUnixtTimeToDateTime(list.recordedDate);
  const onClickMediaDetail = `onClickMediaDetail${idx}`;

  return (
    <List
      role="presentation"
      id={onClickMediaDetail}
      key={idx}
      className="button"
      onClick={() => open(list.id)}
    >
      <Thumbnail>
        <ImageWrapper>
          {(list.orientation === 'P' && (
            <MediaIconP
              src={getMediaIconSrc(mediaType, thumbnailUrl)}
              alt="IMG"
            />
          )) || (
            <MediaIconL
              src={getMediaIconSrc(mediaType, thumbnailUrl)}
              alt="IMG"
            />
          )}
          {list.mediaType === VIDEO && list.thumbnailUrl && (
            <PlayCircle style={PlayCircleStyle} />
          )}
        </ImageWrapper>
      </Thumbnail>
      <div style={style.description}>
        <Operator01>
          <div style={style.time}>{convertRecordedDate}</div>
        </Operator01>
      </div>
    </List>
  );
};

const TimeLineTileLists = ({
  searchBoxHeight,
  enableRemoteButton,
  timelines,
  currentOperator,
  pagenation,
  searchOptions,
  onSelect,
  userDevices,
  mediaInfo,
  onSendLocation,
  onDeleteDevice,
  onRemoteSupportEnd,
  onToggleTimelineTile,
  companyLicenseInfo,
  innerRole,
  checkbox,
  searchOptionsError,
  fullscreenMap,
  onSearch,
  calendarData,
  onOpenCalendar,
  onCloseCalendar,
  tags,
  selectedTagIds,
  openDetail,
  isTimelineTile,
  onToggleMapFullScreen,
  onCheckLists,
  onSortLists,
  apiToken,
  dispatch,
  timeLineScreenMode,
  executeEvent,
  openUpdateTagsDialog,
  openBlackboardList,
  noGroupSelected,
  userGroups,
  targetGroupId,
}) => {
  const intl = useIntl();
  const { formatMessage } = intl;
  const operatorId = (currentOperator && currentOperator.operatorId) || '';
  const dispName = (currentOperator && currentOperator.name) || '';
  const linkDisplayList = `/ds/timelinelist/${operatorId}`;
  const linkDisplayTile = `/ds/timelinetile/${operatorId}`;
  const displayDeleteData = deleteData.indexOf(innerRole) !== -1;
  const displayMap =
    mediaInfo.lat !== undefined &&
    mediaInfo.lng !== undefined &&
    mediaInfo.lat !== null &&
    mediaInfo.lng !== null;
  return (
    <div style={style.main} className="timeLineListsts">
      <div style={style.contents}>
        <OperatorInfo>
          <OperatorBox>
            <div style={style.operatorInfoBox}>
              <OperatorImage>
                <UserIcon
                  size={60}
                  url={currentOperator && currentOperator.iconUrl}
                />
              </OperatorImage>
              <div style={style.operatorName}>{dispName}</div>
            </div>
          </OperatorBox>
          <DeviceList
            currentOperator={currentOperator}
            userDevices={userDevices}
            enableRemoteButton={enableRemoteButton}
            onDelete={id => onDeleteDevice(id)}
            onRemoteSupportEnd={id => onRemoteSupportEnd(id)}
            onSendLocation={id => onSendLocation(id)}
            openBlackboardList={id => openBlackboardList(id)}
          />
          {displayMap && (
            <MapBox>
              <MediaMap
                mediaInfo={mediaInfo}
                fullscreen={fullscreenMap}
                onToggleFullScreen={onToggleMapFullScreen}
              />
            </MapBox>
          )}
        </OperatorInfo>
        <TitleBar>
          <TitleBarText>
            <FormattedMessage id="timeLine.title" />
          </TitleBarText>
          <ToolButton>
            <ToolIcon
              id="clickTimelineListToTile"
              src={iconGrid}
              alt="grid"
              selected={isTimelineTile}
              selectable
              onClick={() =>
                isTimelineTile
                  ? undefined
                  : onToggleTimelineTile(linkDisplayTile)
              }
            />
            <ToolIcon
              id="clickTimelineTileToList"
              src={iconList}
              alt="lint"
              selected={!isTimelineTile}
              selectable={isTimelineTile && timelines && timelines.length > 0}
              onClick={() =>
                isTimelineTile && timelines && timelines.length > 0
                  ? onToggleTimelineTile(linkDisplayList)
                  : undefined
              }
            />
          </ToolButton>
        </TitleBar>
        {isTimelineTile && (
          <Table>
            <Tbody id="canScrollTable">
              {(timelines &&
                timelines.length > 0 &&
                timelines.map((list, idx) =>
                  createList(intl, idx, list, openDetail),
                )) || (
                <div style={style.nodata}>
                  <div>
                    <FormattedMessage id="timeLine.nodata" />
                  </div>
                </div>
              )}
            </Tbody>
          </Table>
        )}
        {!isTimelineTile && (
          <Table>
            <TimeLineSearchBox
              displayDeleteData={displayDeleteData}
              searchOptions={searchOptions}
              searchOptionsError={searchOptionsError}
              checkbox={checkbox}
              onSearch={onSearch}
              isGeneralUser
              calendarData={calendarData}
              onOpenCalendar={onOpenCalendar}
              onCloseCalendar={onCloseCalendar}
              tags={tags}
              selectedTagIds={selectedTagIds}
              isShowSaveSearchCriteria={false}
              hideGroupSelection
            />
            <TimeLineToolBar
              innerRole={innerRole}
              checkbox={checkbox}
              executeEvent={executeEvent}
              timelines={timelines}
              timeLineScreenMode={timeLineScreenMode}
              onCheck={(value, checked) =>
                dispatch({
                  type: 'TIMELINELISTS_CHECKBOX_CHECK',
                  value,
                  checked,
                })
              }
              onUpdateExecuteEvent={e => {
                dispatch({
                  type: 'UPDATE_EXECUTE_EVENT',
                  executeEvent: e.target.value,
                });
              }}
              onDownloadClick={() => {
                if (checkbox.ids.length > 0) {
                  download(dispatch, apiToken, checkbox.ids, targetGroupId);
                }
              }}
              onDownloadCheckResultClick={() => {
                if (checkbox.ids.length > 0) {
                  downloadCheckResult(dispatch, apiToken, checkbox.ids);
                }
              }}
              onUpdateTagsClick={() => {
                if (checkbox.ids.length > 0) {
                  dispatch({ type: 'OPEN_UPDATE_TAGS_DIALOG' });
                }
              }}
              onDataDeleteClick={params => {
                if (checkbox.ids.length > 0) {
                  disableWorkRecords(dispatch, apiToken, formatMessage, params);
                }
              }}
              isShowDownload
              isShowDownloadCheckResult
              isShowEditTag
              isShowDelete
              onChangeDisplayTag={params => {
                dispatch({ type: 'CHANGE_DISPLAY_TAG', params });
              }}
            />
            <ListsWrapper searchBoxHeight={searchBoxHeight}>
              <TimeLineLists
                fullscreen
                noGroupSelected={noGroupSelected}
                timelines={timelines}
                searchOptions={searchOptions}
                checkbox={checkbox}
                companyLicenseInfo={companyLicenseInfo}
                userGroups={userGroups}
                openDetail={openDetail}
                onCheck={onCheckLists}
                onSort={onSortLists}
              />
            </ListsWrapper>
          </Table>
        )}
        <TimeLinePagenation
          pagenation={pagenation}
          searchOptions={searchOptions}
          onSelect={page => onSelect(page)}
        />
      </div>
      {openUpdateTagsDialog && <UpdateTagsDialog checkbox={checkbox} />}
    </div>
  );
};

TimeLineTileLists.propTypes = {
  searchBoxHeight: PropTypes.number.isRequired,
  enableRemoteButton: PropTypes.bool.isRequired,
  timelines: PropTypes.array.isRequired,
  currentOperator: PropTypes.object.isRequired,
  pagenation: PropTypes.object.isRequired,
  searchOptions: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  userDevices: PropTypes.array.isRequired,
  mediaInfo: PropTypes.object.isRequired,
  onSendLocation: PropTypes.func.isRequired,
  onDeleteDevice: PropTypes.func.isRequired,
  openBlackboardList: PropTypes.func.isRequired,
  onRemoteSupportEnd: PropTypes.func.isRequired,
  onToggleTimelineTile: PropTypes.func.isRequired,
  companyLicenseInfo: PropTypes.object.isRequired,
  innerRole: PropTypes.number.isRequired,
  checkbox: PropTypes.object.isRequired,
  searchOptionsError: PropTypes.object.isRequired,
  fullscreenMap: PropTypes.bool.isRequired,
  onSearch: PropTypes.func.isRequired,
  calendarData: PropTypes.object.isRequired,
  onOpenCalendar: PropTypes.func.isRequired,
  onCloseCalendar: PropTypes.func.isRequired,
  tags: PropTypes.object.isRequired,
  selectedTagIds: PropTypes.array.isRequired,
  openDetail: PropTypes.func.isRequired,
  isTimelineTile: PropTypes.bool.isRequired,
  onToggleMapFullScreen: PropTypes.func.isRequired,
  onCheckLists: PropTypes.func.isRequired,
  onSortLists: PropTypes.func.isRequired,
  apiToken: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  timeLineScreenMode: PropTypes.number.isRequired,
  executeEvent: PropTypes.string.isRequired,
  openUpdateTagsDialog: PropTypes.bool.isRequired,
  noGroupSelected: PropTypes.bool.isRequired,
  userGroups: PropTypes.array.isRequired,
  targetGroupId: PropTypes.string.isRequired,
};

export default TimeLineTileLists;
